// ComfyHug — barra sticky de "Añadir al carrito"
// Escritorio: aparece cuando el botón original de compra sale del viewport (por arriba).
// Móvil: aparece abajo siempre que el botón original no esté a la vista (también al abrir la página).
(function () {
  function initStickyAtc() {
    var bar = document.querySelector('[data-mt-sticky-atc]');
    var trigger = document.querySelector('[data-mt-submit]');
    if (!bar || !trigger) return;

    var realPrice = document.querySelector('[data-mt-precio-actual]');
    var realBtnText = trigger.querySelector('[data-mt-submit-text]');
    var barPrice = bar.querySelector('[data-mt-sticky-precio]');
    var barBtn = bar.querySelector('[data-mt-sticky-submit]');
    var barBtnText = bar.querySelector('[data-mt-sticky-submit-text]');

    function syncPrecio() {
      if (realPrice && barPrice) barPrice.textContent = realPrice.textContent;
    }

    function syncEstado() {
      if (barBtn) barBtn.disabled = trigger.disabled;
      if (realBtnText && barBtnText) barBtnText.textContent = realBtnText.textContent.split(' · ')[0].trim();
    }

    syncPrecio();
    syncEstado();

    if (realPrice) {
      new MutationObserver(syncPrecio).observe(realPrice, { characterData: true, childList: true, subtree: true });
    }
    new MutationObserver(syncEstado).observe(trigger, { attributes: true, attributeFilter: ['disabled'] });
    if (realBtnText) {
      new MutationObserver(syncEstado).observe(realBtnText, { characterData: true, childList: true, subtree: true });
    }

    if (barBtn) {
      barBtn.addEventListener('click', function () {
        if (trigger.disabled) return;
        trigger.click();
      });
    }

    var io = null;
    var movil = window.matchMedia('(max-width: 749px)');

    function crearObservador() {
      if (io) io.disconnect();
      var headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
      io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var fuera = !entry.isIntersecting;
            var pasado = fuera && (movil.matches || entry.boundingClientRect.top < 0);
            bar.classList.toggle('mt-sticky-atc--visible', pasado);
            bar.setAttribute('aria-hidden', pasado ? 'false' : 'true');
          });
        },
        { threshold: 0, rootMargin: '-' + headerHeight + 'px 0px 0px 0px' }
      );
      io.observe(trigger);
    }

    crearObservador();

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(crearObservador, 200);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAtc);
  } else {
    initStickyAtc();
  }
})();

// Precio grande de la ficha: refleja el pack elegido (1x / 2x) y la cantidad.
// El sticky se actualiza solo porque observa el precio grande.
(function () {
  function initPrecioPack() {
    var wrap = document.querySelector('[data-mt-tiers]');
    var form = document.querySelector('[data-mt-producto-form]');
    var precio = document.querySelector('[data-mt-precio-actual]');
    if (!wrap || !form || !precio) return;

    var tachado = document.querySelector('[data-mt-precio-tachado]');
    var tiers = Array.prototype.slice.call(wrap.querySelectorAll('[data-mt-tier]'));
    var cantidad = document.querySelector('[data-mt-cantidad] input');
    var idInput = form.querySelector('input[name="id"]');
    var variants = [];
    try {
      var json = form.querySelector('[data-mt-variants-json]');
      if (json) variants = JSON.parse(json.textContent);
    } catch (e) {}

    function fmt(amount) {
      var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'MXN';
      return '$' + amount.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ' + cur;
    }

    function variantePrecios() {
      var id = idInput ? parseInt(idInput.value, 10) : 0;
      var v = variants.filter(function (x) { return x.id === id; })[0];
      if (v) return { price: v.price / 100, compare: (v.compare_at_price || 0) / 100 };
      return {
        price: parseInt(wrap.getAttribute('data-unit-price-cents'), 10) / 100,
        compare: (parseInt(wrap.getAttribute('data-compare-cents'), 10) || 0) / 100
      };
    }

    function actualizar() {
      var qty = cantidad ? Math.max(1, parseInt(cantidad.value, 10) || 1) : 1;
      var descuento = 0;
      tiers.forEach(function (t) {
        if (parseInt(t.getAttribute('data-qty'), 10) === qty) descuento = parseFloat(t.getAttribute('data-discount')) || 0;
      });
      var p = variantePrecios();
      if (!p.price) return;
      precio.textContent = fmt(p.price * qty * (1 - descuento / 100));
      if (tachado) {
        if (p.compare > p.price) {
          tachado.textContent = fmt(p.compare * qty);
          tachado.hidden = false;
        } else {
          tachado.hidden = true;
        }
      }
    }

    // Esperamos un instante para ir DESPUÉS de los demás scripts (pack, +/-, variante).
    function despues() { window.setTimeout(actualizar, 0); }

    wrap.addEventListener('click', despues);
    var cantWrap = document.querySelector('[data-mt-cantidad]');
    if (cantWrap) {
      cantWrap.addEventListener('click', despues);
      cantWrap.addEventListener('input', despues);
    }
    form.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.mt-producto__pill')) despues();
    });
    despues();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPrecioPack);
  } else {
    initPrecioPack();
  }
})();
